import { get, post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true };

/** 根据资源库项目 ID 查询点位，点位名称搜索在调用方完成。 */
export function getChancePointPlaceSpots(params: any) {
  return get('/spot/listByPlaceId', params, OPTIONS);
}

/** 保存机会点与资源库项目、点位的关联。 */
export function saveChancePointPlaceSpot(params: any) {
  return post('/standard/chancePoint/savePlaceSpot', params, OPTIONS);
}
